<template>
    <div v-if="errorOffice !== ''" class="error-sso-code">
        <h2 class="pending-sso">
            {{ $t("sso.error") }}
        </h2>
        <div
            v-if="errorOffice === 'EMAIL_INVALID_OR_UNKNOWN'"
            class="error-sso-code"
        >
            <div>{{ $t("sso.manyAccount") }}</div>
            <basic-button type="submit" @click="goToLoginPage()" class="button">
                <span>
                    {{ $t("sso.buttonManyAccount") }}
                </span>
            </basic-button>
        </div>
    </div>
    <div v-else>
        <h2 class="pending-sso">
            {{ $t("sso.pending") }}
        </h2>
    </div>
</template>

<script>
import httpIntratone from "@/services/httpIntratone.js"
import { isSSOAvailable } from "@/helpers/countryRestrictions"
import { useToast } from "vue-toastification"
import BasicButton from "@/components/basic/BasicButton.vue"
import connexion from "@/mixins/connexion"

const toast = useToast()
export default {
    name: "sso",
    components: { BasicButton },
    mixins: [connexion],
    mounted() {
        this.loginWithCode()
    },
    data() {
        return {
            SID: null,
            errorOffice: "",
        }
    },
    methods: {
        goToLoginPage() {
            this.$router.push({
                name: "Login",
                query: {
                    reload: true,
                },
            })
        },

        loginWithCode() {
            let params_login = new URLSearchParams()
            params_login.append("redirect_uri", "/sso/microsoft/")
            params_login.append("code_office", this.$route.query.code)
            httpIntratone
                .post("connexion.php", params_login)
                .then(async (response) => {
                    if (response.data.code === "PARAMS_INVALID") {
                        this.goToLoginPage()
                        toast.error(this.$t("sso.globalError"), {
                            icon: "fas fa-exclamation-circle",
                            timeout: 10000,
                        })
                    } else if (
                        response.data.code === "EMAIL_INVALID_OR_UNKNOWN"
                    ) {
                        this.errorOffice = "EMAIL_INVALID_OR_UNKNOWN"
                    } else if (response.data.code === "LOGIN_FAILED") {
                        this.goToLoginPage()
                        toast.error(this.$t("sso.loginAccount"), {
                            icon: "fas fa-exclamation-circle",
                            timeout: 10000,
                        })
                    } else if (
                        response.data.terms_of_uses &&
                        !response.data.jwt
                    ) {
                        this.SID = response.data.SID
                        this.termsOfUsesModale(response.data.terms_of_uses.url)
                    } else {
                        await this.connexion(response)
                        this.$store.dispatch("doubleAuth/setErrorMessage", "")
                    }
                })
        },

        initHomeToBreadCrumb(direction) {
            this.$store.commit("breadCrumb/setClassicBreadCrumb", [
                {
                    name: this.$t("global.entities.home"),
                    link:
                        direction === "résidences"
                            ? "/residences"
                            : "/v1/data/accueil/accueil",
                },
            ])
        },
    },

    beforeCreate() {
        if (!isSSOAvailable()) {
            this.$router.push({ name: "Login" })
        }
    },
}
</script>

<style lang="scss" scoped>
@import "@/assets/scss/global.scss";
@import "@/assets/scss/variables/fontSize.scss";

.pending-sso {
    padding-top: 60px;
    font-family: $font_avenir_black;
    font-size: $semiBig;
    margin: 0;
}

.error-sso-code {
    display: flex;
    flex-direction: column;
    gap: 10px;
}
.button {
    align-self: center;
}
</style>
